import { render, staticRenderFns } from "./CardProcessInfo.vue?vue&type=template&id=c150fd4e&scoped=true&"
import script from "./CardProcessInfo.vue?vue&type=script&lang=js&"
export * from "./CardProcessInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardProcessInfo.vue?vue&type=style&index=0&id=c150fd4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c150fd4e",
  null
  
)

export default component.exports